import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { PedidosServiceV2 } from '@servicesv2';
import { MessageService } from '@services';
import { saveAs } from 'file-saver';
import { getErrorMessage } from '@utils';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-modal-consulta-faturamento-pedido',
  templateUrl: './modal-consulta-faturamento-pedido.component.html',
  styleUrls: ['./modal-consulta-faturamento-pedido.component.css']
})
export class ModalConsultaFaturamentoPedidoComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modal', { static: true }) modal;

  selecionados: any;
  entrega1: Date;
  entrega2: Date;
  fornecedorId: number;

  constructor(
    private serviceV2: PedidosServiceV2,
    private messageService: MessageService
  ) {
    super();
  }

  ngOnInit(): void {
    const { ids, entrega1, entrega2, fornecedorId } = this.prop || { ids: [], entrega1: null, entrega2: null, fornecedorId: null };
    this.selecionados = ids;
    this.entrega1 = entrega1;
    this.entrega2 = entrega2;
    this.fornecedorId = fornecedorId;
  }

  show(): void {
    this.modal.show();
  }

  close(): void {
    this.modal.hide();
  }

  onClose() {
    this.closed.emit();
  }

  async imprimirColetaEstoque() {
    this.loading['impressao-coleta'] = true;

    try {
      const filtro = {
        ids: this.selecionados,
        dataInicial: this.entrega1,
        dataFinal: this.entrega2,
        fornecedorId: this.fornecedorId,
      };
      const res = await this.serviceV2.imprimirColetaEstoque(filtro);
      saveAs(res, `relatorio_coleta_estoque.pdf`);
    } catch (error) {
      console.error(error);
      this.messageService.error(getErrorMessage(error), 0, 'Erro ao imprimir coleta de estoque.');
    } finally {
      this.loading['impressao-coleta'] = false;
    }
  }

  emissaoNFe() {
    this.closed.emit('emissaoNfe');
  }

  minutaTransporte() {
    this.messageService.warning("Função em desenvolvimento.");
  }
}
